import { render, staticRenderFns } from "./ShiftCardCompact.vue?vue&type=template&id=df5df9f8&"
import script from "./ShiftCardCompact.vue?vue&type=script&lang=js&"
export * from "./ShiftCardCompact.vue?vue&type=script&lang=js&"
import style0 from "./ShiftCardCompact.vue?vue&type=style&index=0&id=df5df9f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports